import axios from 'axios'
import { ref } from 'vue'
import { useToast } from 'vue-toast-notification'

export function useInvoices({
    onDeleted = () => {},
    onError = () => {},
}) {
    const $toast = useToast()

    const deleting = ref(false)

    const deleteInvoice = async (id) => {
        try {
            deleting.value = true
            await axios.delete(`/api/invoices/${id}`)
            $toast.success('Facture supprimée', {
                position: 'top',
                duration: 5000,
                dismissible: true,
                pauseOnHover: true,
            })
            onDeleted()
        } catch (error) {
            onError(error)
        } finally {
            deleting.value = false
        }
    }

    return {
        deleting,
        deleteInvoice,
    }
}
